const setIEMPrice = (iem) => {
    return {
        type: 'SET_IEM_PRICE',
        payload: iem
    };
};

const setLeftFaceplatePrice = (faceplate) => {
    return {
        type: 'SET_LEFT_FACEPLATE_PRICE',
        payload: faceplate
    };
};

const setRightFaceplatePrice = (faceplate) => {
    return {
        type: 'SET_RIGHT_FACEPLATE_PRICE',
        payload: faceplate
    };
};

const setBothFaceplatePrice = (faceplate) => {
    return {
        type: 'SET_BOTH_FACEPLATE_PRICE',
        payload: faceplate
    };
};
const setLeftArtworkPrice = (artwork) => {
    return {
        type: 'SET_LEFT_ARTWORK_PRICE',
        payload: artwork
    };
};

const setRightArtworkPrice = (artwork) => {
    return {
        type: 'SET_RIGHT_ARTWORK_PRICE',
        payload: artwork
    };
};

const setBothArtworkPrice = (artwork) => {
    return {
        type: 'SET_BOTH_ARTWORK_PRICE',
        payload: artwork
    };
};

const updateBasePrice = (basePrice) => {
    return {
        type: 'UPDATE_BASE_PRICE',
        payload: basePrice
    };
};

const setRushProcessing = (price) => {
    return {
        type: 'SET_RUSH_PROCESSING_PRICE',
        payload: price
    };
};

const setCarePlanPrice = (price) => {
    return {
        type: 'SET_CARE_PLAN_PRICE',
        payload: price
    };
};

// eslint-disable-next-line
export default {
    setIEMPrice,
    setLeftFaceplatePrice,
    setRightFaceplatePrice,
    setBothFaceplatePrice,
    setLeftArtworkPrice,
    setRightArtworkPrice,
    setBothArtworkPrice,
    updateBasePrice,
    setRushProcessing,
    setCarePlanPrice
};
